// @flow
import React, {Component} from 'react'; 
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import {Default, Mobile} from '../../../../utils/responsive';
import {FormValidator} from '../../../../utils/form/index';
import analytics from '../../../../analytics';
import {urlVerifier} from '../../../../utils/string';
 
import style from './TopHomeSearch.scss'; 
import buttonStyle from '../../../../assets/styles/button.scss';
import inputStyle from '../../../../assets/styles/input.scss';

import image1 from '../../../../assets/img/home/top-home-search/image-1.png';
import image2 from '../../../../assets/img/home/top-home-search/image-2.png';
import image3 from '../../../../assets/img/home/top-home-search/image-3.png';
import image4 from '../../../../assets/img/home/top-home-search/image-4.png';
import image5 from '../../../../assets/img/home/top-home-search/image-5.png';
import image6 from '../../../../assets/img/home/top-home-search/image-6.png';
import image7 from '../../../../assets/img/home/top-home-search/image-7.png';
import womanHome from '../../../../assets/img/home/top-home-search/woman-home.png';
import circleBackground from '../../../../assets/img/home/top-home-search/circle-background.png';

import type {FormValidationResult} from '../../../../utils/form';
import type {LocaleState} from '../../../locale/duck';

type Props = {
  +goToRedirect: (route: string) => void;
  +locale: LocaleState;
};

type State = {
  url: {
    value: string;
    errors?: string[];
  }; 
};
 
export default class TopHomeSearch extends Component<Props, State> {
  formValidator: FormValidator;
  state = {
    url: {
      value: '',
    }, 
  };

  constructor(props: Props) {
    super(props);
    this.formValidator = new FormValidator({
      url: {
        required: 'required',
      },
    });
  }

  handleSubmit = (e: Event) => {
    e.preventDefault();
    const {goToRedirect, locale} = this.props;
    const {url} = this.state;
    const errors = this.formValidator.validateForm({
      url: url.value,
    });

    analytics.fireCustomEvent('Home Main Button Clicked', {
      category: 'Home Main Button',
      action: 'Clicked',
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      url: url.value || '',
      domain_country: locale.domainCountry,
    });

    if (errors.length) {
      errors.forEach(
        (error: FormValidationResult) =>
          this.setState(
            (state: State) => ({
                [error.field]: {
                  ...state[error.field],
                  errors: error.errors,
                },
              }
            )),
      );
    } else {
      if (urlVerifier(url.value) || url.value.startsWith('http')) {
        goToRedirect(`/new-order/product?initialQuery=${url.value}`);
      } else {
        goToRedirect(`/new-order/search?name=${url.value}`);
      }
    }
    return false;
  };
  
  handleFocus = (e: Event) => {
    this.setState((s: State)=> ({
      url: {value: s.url.value}
    }));
  }

  handleBlur = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const { value} = e.target;
      const errors = this.formValidator.validateField('url', value);
      if (errors.length && (errors[0] === 'urlFormat')) {
        this.setState({url: {value, errors}});
      } else {
        this.setState({url: {value}});
      }
    }
  }

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      const {name, value} = e.target;
      this.setState({url: {value}});
    }
  }
 
  render() {
    const {url} = this.state;
    return (
      <div className={style.topHomeSearchWrap}>
        <div className={style.mainWrap}>
          
          <div className={style.leftWrap}>
            <div className={style.containerWrap}>
              <form className={style.formWrap} 
                action="/new-order/product"
                onSubmit={this.handleSubmit}
              >
                {/*<h1 className={style.title}>Compra en USA sin trámites</h1>
                <label className={style.inputLabel}>Busca el producto en la tienda de USA y pega el link</label>*/}
                <h1 className={style.title}>Compra en USA sin impuestos con los viajeros de Qempo</h1>
                <label className={style.inputLabel}>Busca el producto en la tienda de USA y pega el link o ingresa el nombre aquí:</label>
                <section className={style.inputWrap}>
                  <input 
                    placeholder="Ej: www.tienda.com/producto"
                    type="text"
                    name="initialQuery"
                    className={classNames(inputStyle.input, style.input,
                      {[inputStyle.red]: url.errors && url.errors.length})}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                    onChange={this.handleChange}
                  />
                  <button  
                    type="submit"
                    className={classNames(buttonStyle.btn,
                    buttonStyle.orange,
                    style.button)}>Cotizar GRATIS</button>
                </section>
              </form>
            </div>
          </div>

          <div className={style.rightWrap}>
            <div className={style.squareWrap}>
              <div className={style.contentWrap} style={{background: `url(${circleBackground}) no-repeat`}}>
                <img src={image1} className={style.image1}/>
                <img src={image2} className={style.image2}/>
                <img src={image3} className={style.image3}/>
                <img src={image4} className={style.image4}/>
                <img src={image5} className={style.image5}/>
                <img src={image6} className={style.image6}/>
                <img src={image7} className={style.image7}/>    
                <div className={style.wrapMainImage}>
                  <img src={womanHome} className={style.womanHomeImage}/>
                </div>
              </div>
            </div>
          </div>   
        </div>
      </div>
    );
  }
}


TopHomeSearch.propTypes = { 
  goToRedirect: PropTypes.func.isRequired,
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/home/elements/TopHomeSearch/TopHomeSearch.jsx